import React from 'react';
import { COLORS } from '../constants';

// In Production — the day's throughput.
//
// WHAT THIS REPLACED, AND WHY. The first version headlined lifetime totals:
// 975 Total, 151 Accepted. The desk reported them as unreadable, and they were
// right — those are a standing backlog that barely moves from one day to the
// next, so they answer no question anyone actually has. Production accepts
// about 30 stories a day. That is the number worth the space.
//
// NEW is not like the other four. It counts suggestions that ARRIVED today
// (444 landed overnight on 2026-10-03) — status `suggestion`, which this
// screen deliberately excludes. It is an inflow reading, so the table below
// will never add up to it. Hence the divider: it belongs to a different
// question from the four that follow.
const SEGMENTS = [
  { key: 'new', label: 'New today', accent: COLORS.slate, detached: true },
  { key: 'accepted', label: 'Accepted', accent: COLORS.blue },
  { key: 'in_work', label: 'In work', accent: COLORS.orange },
  { key: 'completed', label: 'Completed', accent: COLORS.blueNavy },
  { key: 'sent_to_publisher', label: 'Sent', accent: COLORS.blueSlate },
];

const HANDLED = { key: 'handled_by_publisher', label: 'Handled', accent: COLORS.slate };

export default function InProductionSummary({ counts = {}, writtenBy = 'alchemiq', scopeLabel }) {
  // "Handled by publisher" only exists where a publisher-written bucket is in
  // scope; in the Alchemiq view it would be a permanently empty column.
  const segments = writtenBy === 'alchemiq' ? SEGMENTS : [...SEGMENTS, HANDLED];

  return (
    <div className="pbnew-ip-today">
      <div className="pbnew-ip-today-head">
        <span className="pbnew-ip-today-title">Today</span>
        {scopeLabel && <span className="pbnew-ip-today-scope">{scopeLabel}</span>}
      </div>
      <div
        className="pbnew-ip-summary"
        role="group"
        aria-label="Today's figures"
        style={{ gridTemplateColumns: `repeat(${segments.length}, 1fr)` }}
      >
        {segments.map((seg) => (
          <div
            className={`pbnew-ip-summary-seg ${seg.detached ? 'detached' : ''}`}
            key={seg.key}
            style={{ '--seg-accent': seg.accent }}
          >
            <div className="pbnew-ip-summary-num">{counts[seg.key] || 0}</div>
            <div className="pbnew-ip-summary-label">{seg.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
